<template>
  <div
    class="context-menu-option"
    :class="{'context-menu-option--disabled': disabled}"
    @click="$emit('click', $event)"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean
  }
}
</script>

<style lang="scss">
.context-menu-option {
  padding: 7px 8px;
  font-style: italic;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &--disabled {
    color: $inactiveGrey;
    pointer-events: none;
  }

  &:hover {
    background-color: $messageHover;
  }
}
</style>
